var _ = require('underscore');
var Approval = require('RecordActionApprove');
var Entities = require('Entities');
var ApproverGroups = new Backbone.Collection(EY.Consultation.Resources.ApproverGroup);
var User = EY.Consultation.CurrentUser;
var Offset = 100;

module.exports.describe = function () {
    describe('Record Action Approval', function () {
        var options = {
            approvers: new Entities.Approvers(),
            record: new Entities.Record({
                approverGroupId: '',
                assignedTo: User.upn
            })
        };

        // Reset for each expectation.
        beforeEach(function () {
            ApproverGroups.each(function (group, index) {
                options.approvers.add(new Entities.Approver({
                    id: _.now() + '' + index,
                    approverGroupId: group.id,
                    order: group.get('order') * Offset,
                    givenName: User.givenName,
                    upn: User.upn
                }));
            });
        });

        it('should be able to approve', function () {
            var approver = options.approvers.first();
            Approval.run(options);
            expect(options.record.get('assignedToUser')).toEqual(approver.get('userDomainName'));
        });

        // Other expectations, if any...
    });
};


// WEBPACK FOOTER //
// ./test/Specs/Functional/RecordActionApprove.js